<template>
  <div>
    <div class="site-header row">
      <div class="col-4"></div>
      <div class="col-4">
        <img src="../../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <h1 v-if="loginFields" class="text-center login-header">LOG IN</h1>
    <h1 v-else class="text-center login-header">SIGN UP</h1>
    <div class="justify-content-center text-center login-page">
      <br/>
      <div class="login-content">
        <Login v-show="loginFields" :nextPath="previousPath.path"/>
        <SignUp v-show="loginFields === false" :nextPath="previousPath.path"/>

        <p class="text-center mt-1 mb-1">or</p>

        <div class="row justify-content-center">
          <span class="btn col-sm-6 btn-primary" v-if="loginFields" @click="toggleLogin">Sign Up Here</span>
          <span class="btn col-sm-6 btn-primary" v-else @click="toggleLogin">Login Here</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./Login"
import SignUp from "./SignUp"

export default {
  components:{
    Login,
    SignUp
  },
  data(){
    return {
      loginFields: true,
      previousPath: '/'
    }
  },
  methods:{
    toggleLogin(){
      this.loginFields = !this.loginFields
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousPath = from
      vm.$store.commit('setAfterLoginPath', from.fullPath)
    })
  }
}
</script>

<style lang="scss" scoped>

.login-header {
  margin-top: 2em;
  margin-bottom: 2em;
}

.login-page {
  max-width: 60%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2em;
  margin-bottom: 3em;
  background-color: white;
}

</style>
